module.exports = __webpack_public_path__ + "static/media/excel.44930832.svg";